import { init } from '@aimitojs/browser'
import { vuePlugin } from '@aimitojs/vue'
import config from '@/config/user.env'
import store from '@/store'

export function setupMonitor(app) {
    if (config.feMonitorAppKey) {
        init(
            {
                vue: app,
                appKey: config.feMonitorAppKey,
                serviceName: 'c-ntp-web-hz',
                dsn: 'https://mwmr.midea.com/xops/web-endpoint/report',
                backUserId() {
                    return `${store.getters.identityInfo.mobile}-${store.getters.identityInfo.customerCode}`
                },
            },
            [vuePlugin],
        )
    }
}
